import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { DeleteJson } from '@awp/helpers/fetchReact';
import AwpYesNoModal from '@components/Common/AwpYesNoModal';
import { REST_API, EventTypes } from '@awp/constants';
import { startOfDay, endOfDay } from 'date-fns';

const HazardForecastDeleteButton = ({ event, startDate, setStartDate, endDate, setEndDate }) => {
  const [showYesNoModal, setShowYesNoModal] = useState(false);

  if (!event || event.EventTypeNm !== EventTypes.HazardForecast) return null;

  const canDelete = ['Created', 'Edited', 'Duplicated'].includes(event.Status);
  if (!canDelete) return null;

  const url = REST_API.HAZARD_FORECAST + event.EventId;
  const handleDelete = async () => {
    DeleteJson(url, {})
      .then((response) => {
        if (response.ok) {
          toast.success('Hazard Forecast has been deleted');
          let _startDate = {
            value: new Date(startOfDay(new Date().setDate(new Date().getDate() - 14))),
            disabled: false,
            error: '',
          };
          setStartDate(_startDate);
          setEndDate({ value: new Date(endOfDay(new Date())), disabled: false, error: '' });
        } else {
          toast.error('Failed to delete a Hazard Forecast');
        }
      })
      .finally(() => {
        setShowYesNoModal(false);
      });
  };

  return (
    <>
      <i className="fas fa-trash mx-1 my-1 awp-img-btn" title="Delete" onClick={() => setShowYesNoModal(true)}></i>
      <AwpYesNoModal
        showYesNoModal={showYesNoModal}
        setShowYesNoModal={setShowYesNoModal}
        onClickYes={handleDelete}
        title="Delete"
        body="Are you sure you want to delete?"
      />
    </>
  );
};

HazardForecastDeleteButton.propTypes = {
  event: PropTypes.any,
};

export default HazardForecastDeleteButton;
